import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusFlash"><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16M12 8L9.5 12H14.5L12 16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFocusFlash;
